module.exports = __webpack_public_path__ + "img/sheffield-united.417efa40.png";